import history from 'app/history';

export default function navigateTo(routeStr) {
  history.get().push(routeStr);
}
